export default __webpack_public_path__ + "static/media/ds_clock_disc.7079f417.png";